import GamesConfig from "./GamesConfig"
import { Global } from "../Shared/Global";
import GameList from "../Models/GameList";
import Constant from "../Shared/Constant";
import ThirdGameItem from "./ThirdGameItem";

const {ccclass, property} = cc._decorator;

@ccclass
export default class SportsLayer extends cc.Component {
    @property(cc.Prefab)
    pfbGameItem: cc.Prefab = null
    
    @property(cc.Layout)
    layoutItems: cc.Layout = null

    @property(cc.Animation)
    aniItems: cc.Animation = null
    
    @property(cc.Widget)
    wgtScrollView: cc.Widget = null

    private _nodeItems: cc.Node[] = []

    onLoad () {
        this.layoutItems.node.removeAllChildren()

        if (cc.winSize.width / cc.winSize.height > 2) {
            this.wgtScrollView.left += Constant.BangLength
        }

        cc.director.on(Global.UserEvent.GameListChanged, this.createNodeItems, this)
    }

    onEnable () {
        if (GameList.serverData) {
            this.showItems()
        }
    }

    onDisable () {
        this.aniItems.stop()
    }

    onDestroy () {
        cc.director.off(Global.UserEvent.GameListChanged, this.createNodeItems, this)
    }

    createNodeItems () {
        if (!GameList.serverData) {
            return
        }
        
        let data = GameList.getGameListByType(Global.GameType.Sport)
        let gamesCfg = data["twoLevelList"] || []
        // this.createGameItemsFromServer(gamesCfg)
        this.createGameItemsFromLocal(gamesCfg)
    }

    private createGameItemsFromLocal (gamesCfg) {
        gamesCfg.forEach(item => {
            let node = new cc.Node()
            let nodeSprite = new cc.Node()
            let sprite = nodeSprite.addComponent(cc.Sprite)
            let button = node.addComponent(cc.Button)
            let res = GamesConfig.sports[item.gameTitleCn]
            
            nodeSprite.parent = node
            node.parent = this.layoutItems.node
            this._nodeItems.push(node)

            if (!res) {
                res = "Hall/Sports/huangguan"

                if (Constant.RemindMissingRes) {
                    let nodeLabel = new cc.Node()
                    let lbLack = nodeLabel.addComponent(cc.Label)
                    
                    nodeLabel.color = cc.color(255, 0, 0)
                    nodeLabel.parent = node
                    lbLack.string = item.gameTitleCn + "\n缺少美术资源！"
                    lbLack.fontSize = 40
                }
            }
            
            cc.loader.loadRes(res, cc.SpriteFrame, function (err, spriteFrame) {
                if (!err && this.node) {
                    sprite.spriteFrame = spriteFrame
                    node.width = nodeSprite.width
                    node.height = nodeSprite.height
                }
            }.bind(this))

            // 游戏维护
            if (item.gameStatus === "2") {
                let nodeMaintenance = new cc.Node()
                let spMaintenance = nodeMaintenance.addComponent(cc.Sprite)
                
                nodeMaintenance.parent = node
                nodeSprite.color = cc.color(70, 70, 70)

                cc.loader.loadRes("Common/maintenance", cc.SpriteFrame, function (err, spriteFrame) {
                    if (!err && spMaintenance && spMaintenance.isValid) {
                        spMaintenance.spriteFrame = spriteFrame
                    }
                }.bind(this))
            }

            let clickEventHandler = new cc.Component.EventHandler()
            clickEventHandler.target = cc.find("Canvas/gameNode")
            clickEventHandler.component = "HallUI"
            clickEventHandler.handler = "onGameItemClick"
            button.clickEvents.push(clickEventHandler)
            button.transition = cc.Button.Transition.SCALE
            button.zoomScale = 0.9
            button.node["gameConfig"] = item
        });
    }

    private createGameItemsFromServer (gamesCfg) {
        gamesCfg.forEach(item => {
            let node = cc.instantiate(this.pfbGameItem)
            let gameItem = node.getComponent(ThirdGameItem)
            let button = node.getChildByName("node").addComponent(cc.Button)
            let clickEventHandler = new cc.Component.EventHandler()
            
            node.parent = this.layoutItems.node
            gameItem.urlImgPrefix = GameList.serverData["imgPrefix"]
            gameItem.gameConfig = item
            clickEventHandler.target = cc.find("Canvas/gameNode")
            clickEventHandler.component = "HallUI"
            clickEventHandler.handler = "onGameItemClick"
            button.clickEvents.push(clickEventHandler)
            button.transition = cc.Button.Transition.SCALE
            button.zoomScale = 0.9
            button.node["gameConfig"] = gameItem.gameConfig
        });
    }

    private showItems () {
        if (this.layoutItems.node.children.length === 0) {
            return
        }

        this.layoutItems.enabled = true
        this.layoutItems.updateLayout()
        this.layoutItems.enabled = false
        let length = this.layoutItems.node.convertToNodeSpaceAR(this.node.convertToWorldSpaceAR(cc.v2(this.node.width * this.node.anchorX, 0))).x - this.layoutItems.node.children[0].x - this.layoutItems.node.children[0].width / 2

        this.layoutItems.node.children.forEach(child => {
            let oldPos = child.position
            child.x += length
            child.runAction(cc.moveTo(0.3, oldPos).easing(cc.easeSineOut()))
        });
    }
}
